import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import { format } from 'date-fns';
import AdminInteractions from './admininteractionsnonav';

export default function Home() {
  const [stats, setStats] = useState([
    { name: 'Active Companies', stat: '-' },
    { name: 'Total MRR', stat: '-' },
    { name: 'Avenor Sales Credits (£)', stat: '-' },
    { name: 'Avenor Credits Used (£)', stat: '-' },
  ]);
  const [avenorCompanies, setAvenorCompanies] = useState([]);
  const [table, setTable] = useState([]);
  const [selectedCompanyCode, setSelectedCompanyCode] = useState('');

  const handleOpenInteractions = (companyCode) => {
    setSelectedCompanyCode(companyCode || '');
  };

  const handleStatusToggle = async (companyCode, currentStatus) => {
    const newStatus = currentStatus === 'active' ? 'cancelled' : 'active';
    try {
      const response = await fetch('https://api.insightos.co.uk/admin/admincancelsubscription', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ companyCode, Status: newStatus }),
      });
      if (!response.ok) throw new Error('Failed to update status');
      const data = await response.json();
      if (data.success) {
        setTable(prev =>
          prev.map(c =>
            c.CompanyCode === companyCode ? { ...c, Status: newStatus } : c
          )
        );
      } else {
        alert(data.message || 'Failed to update status');
      }
    } catch (err) {
      alert('Error updating status. Please try again.');
    }
  };

  const handleAvenorStatusChange = async (companyCode, newStatus) => {
    try {
      // Optimistic update
      setAvenorCompanies(prev => prev.map(c => c.CompanyCode === companyCode ? { ...c, Status: newStatus } : c));

      const resp = await fetch('https://api.insightos.co.uk/api/avenor/company/status', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ CompanyCode: companyCode, Status: newStatus }),
      });

      if (!resp.ok) {
        const err = await resp.json().catch(() => null);
        throw new Error(err?.message || 'Failed to update status');
      }

      const data = await resp.json();
      if (data && data.success && data.company) {
        setAvenorCompanies(prev => prev.map(c => (c.CompanyCode === companyCode ? data.company : c)));
      }
    } catch (err) {
      console.error('Failed to update avenor status', err);
      // revert: refetch companies list
      try {
        const r = await fetch('https://api.insightos.co.uk/admin/companies', { credentials: 'include' });
        if (r.ok) {
          const d = await r.json();
          setAvenorCompanies(d.avenorCompanies || []);
        }
      } catch (e) {}
    }
  };

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch('https://api.insightos.co.uk/admin/companies', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include', // Important to send cookies like the JWT
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        const companies = data.data || [];
        const avenor = data.avenorCompanies || [];
        const avenorTotals = data.avenorTotals || null;

        console.log(companies)

        const activeCompanies = companies.filter(company => company.Status === 'active');
        const totalActiveCompanies = activeCompanies.length;



        const totalLastPaymentAmount = activeCompanies.reduce((acc, company) => {
          return acc + parseFloat(company.LastPaymentAmount || 0);
        }, 0);

        setTable(companies);
        setAvenorCompanies(avenor);

        setStats([
          { name: 'Active Companies', stat: totalActiveCompanies },
          { name: 'Total MRR', stat: `£${totalLastPaymentAmount.toLocaleString()}` },
          { name: 'Avenor Sales Credits (£)', stat: avenorTotals ? `£${avenorTotals.totalSalesCreditsGBP.toLocaleString()}` : '£0.00' },
          { name: 'Avenor Credits Used (£)', stat: avenorTotals ? `£${avenorTotals.totalCreditsUsedGBP.toLocaleString()}` : '£0.00' },
        ]);
      } catch (error) {
        console.error('Error fetching stats:', error);
        setStats([
          { name: 'Active Companies', stat: 'Error' },
          { name: 'Total MRR', stat: 'Error' },
          { name: 'Avenor Sales Credits (£)', stat: 'Error' },
          { name: 'Avenor Credits Used (£)', stat: 'Error' },
        ]);
      }
    };

    fetchStats();
  }, []);

  return (
    <>
      <Navbar />
      <div>
        <dl className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5">
          {stats.map((item) => (
            <div key={item.name} className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
              <dt className="truncate text-sm font-medium text-gray-500">{item.name}</dt>
              <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{item.stat}</dd>
            </div>
          ))}
        </dl>
      </div>
      <div className="px-4 sm:px-6 lg:px-8 mt-10">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold text-gray-900">Companies</h1>
            <p className="mt-2 text-sm text-gray-700">
              A list of all companies including all their details.
            </p>
          </div>
        </div>
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Company Code</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Company Name</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Plan</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Users</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Start Date</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Contact Name</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Email</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Telephone</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Company Number</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">City</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Address</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">SageNumber</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">XeroNumber</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Departments</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Stripe Customer Id</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Stripe Subscription Id</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Plan Id</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Status</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Current Period End</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Last Payment Amount</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Sales Credits (£)</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Credits Used (£)</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Onboarded</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">RandomCode</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Email Verified</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Industry</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Website</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">GeoTag</th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Actions</th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {table.map((company) => (
                    <tr key={company.CompanyCode} className="even:bg-gray-50">
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.CompanyCode}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.CompanyName}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.Plan}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.StaffCount} / {company.Users}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{format(new Date(company.StartDate), 'MM/dd/yyyy')}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.ContactName}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.Email}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.Telephone}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.CompanyNumber}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.City}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.Address}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.SageNumber}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.XeroNumber}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.Departments}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.StripeCustomerId}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.StripeSubscriptionId}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.PlanId}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        <button
                          type="button"
                          onClick={() => handleStatusToggle(company.CompanyCode, company.Status)}
                          className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 ${
                            company.Status === 'active' ? 'bg-indigo-600' : 'bg-gray-200'
                          }`}
                          title={company.Status === 'active' ? 'Click to cancel' : 'Click to activate'}
                        >
                          <span
                            className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                              company.Status === 'active' ? 'translate-x-5' : 'translate-x-0'
                            }`}
                          />
                        </button>
                        <span className={`ml-2 text-xs font-medium ${
                          company.Status === 'active' ? 'text-indigo-600' : 'text-gray-400'
                        }`}>
                          {company.Status}
                        </span>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        {company.CurrentPeriodEnd ? format(new Date(company.CurrentPeriodEnd), 'dd/MM/yyyy') : '-'}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.LastPaymentAmount}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.SalesCredits ? `£${(Number(company.SalesCredits) * 0.33).toFixed(2)}` : '-'}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.CreditsUsed ? `£${(Number(company.CreditsUsed) * 0.33).toFixed(2)}` : '-'}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.Onboarded}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.RandomCode}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.EmailVerified}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.Industry}</td>
                     
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.Website}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{company.GeoTag}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                        <button
                          type="button"
                          onClick={() => handleOpenInteractions(company.CompanyCode)}
                          className="rounded-md bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                        >
                          Interactions
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
            {avenorCompanies && avenorCompanies.length > 0 && (
              <div className="px-4 sm:px-6 lg:px-8 mt-12">
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto">
                    <h1 className="text-base font-semibold text-gray-900">Avenor Companies</h1>
                    <p className="mt-2 text-sm text-gray-700">Companies imported from Avenor with sales credits overview.</p>
                  </div>
                </div>
                <div className="mt-6 flow-root">
                  <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                      <table className="min-w-full divide-y divide-gray-300">
                        <thead>
                          <tr>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Company Code</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Company Name</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Contact Name</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Status</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Email</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Email Sent</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Start Date</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Address</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Industry</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Website</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Sales Credits</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Sales Credits (£)</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Credits Used</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Credits Used (£)</th>
                            <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Telephone</th>
                          </tr>
                        </thead>
                        <tbody className="bg-white">
                          {avenorCompanies.map((c) => (
                            <tr key={c.CompanyCode || c.id || c.CompanyName} className="even:bg-gray-50">
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.CompanyCode}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.CompanyName}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.ContactName || '-'}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
                                <select
                                  value={String(c.Status || 'active')}
                                  onChange={(e) => handleAvenorStatusChange(c.CompanyCode, e.target.value)}
                                  className="rounded-md border border-gray-300 bg-white px-2 py-1 text-sm"
                                >
                                  <option value="active">active</option>
                                  <option value="banned">banned</option>
                                  <option value="cancelled">cancelled</option>
                                </select>
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.Email || '-'}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{
                                c.EmailSent ? (
                                  isNaN(Date.parse(c.EmailSent)) ? String(c.EmailSent) : format(new Date(c.EmailSent), 'MM/dd/yyyy')
                                ) : '-'
                              }</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.StartDate ? format(new Date(c.StartDate), 'MM/dd/yyyy') : '-'}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.Address || '-'}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.Industry || '-'}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.Website || '-'}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.SalesCredits ?? 0}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">£{(Number(c.SalesCredits || 0) * 0.33).toFixed(2)}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.CreditsUsed ?? 0}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">£{(Number(c.CreditsUsed || 0) * 0.33).toFixed(2)}</td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{c.Telephone || '-'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}
      </div>
      {selectedCompanyCode && (
        <div className="mt-12 space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-900">Interactions for {selectedCompanyCode}</h2>
            <button
              type="button"
              onClick={() => setSelectedCompanyCode('')}
              className="rounded-md border border-gray-300 px-3 py-1.5 text-sm font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-400"
            >
              Close
            </button>
          </div>
          <div className="rounded-2xl bg-white p-4 shadow">
            <AdminInteractions companyCode={selectedCompanyCode} />
          </div>
        </div>
      )}
    </>
  );
}
